import styled from 'styled-components';

interface UserAvatarProps {
  $avatarSrc: string;
}

export const Container = styled.header`
  font-size: 1rem;
  display: flex;
  align-items: center;
  padding: 0 3.8em;
  background: #fff;
  height: 3.5vw;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  z-index: 1;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SearchBar = styled.div`
  cursor: pointer;
  font-size: 1rem;
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;

  > svg {
    cursor: pointer;
  }
`;

export const LanguageButtons = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;

  > button {
    background: none;
    border: 0;
    font-family: 'MarkPro';
    font-size: 1rem;
    color: #c2c2c2;

    &.active-language {
      color: #323232;
    }
  }

  > button:first-child {
    margin-right: 0.33rem;
  }

  > button:last-child {
    margin-left: 0.33rem;
  }
`;

export const DropdownNotificationContainer = styled.div`
  cursor: pointer;
  display: flex;
  margin: 0px 0.5em 0px 1.8em;
  position: relative;

  > button {
    display: flex;
    align-items: center;
  }

  // The 'nav' item corresponds to Dropdown Component
  > nav {
    z-index: 1500;
    background: #fff;
    border-radius: 0.8rem;
    position: absolute;
    top: calc(100% + 1rem); // Ajustado para ficar abaixo do ícone
    left: 50%;
    width: 16.7rem;
    box-shadow: 0px 10px 30px rgba(85, 85, 85, 0.16);
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, 8px); // Modificado para centralizar corretamente
    transition:
      opacity 0.3s ease,
      transform 0.3s ease,
      visibility 0.3s;

    &.visible {
      opacity: 1;
      visibility: visible;
    }

    &.hidden {
      display: none;
    }

    &::before {
      // Adicionado pseudo-elemento para seta
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fff;
    }

    > ul {
      width: auto;
      padding: 0;
      margin: 0;

      > li {
        white-space: nowrap;
        font-size: 1rem;
        transition: background 0.3s;

        &:first-child {
          border-top-left-radius: 0.8rem;
          border-top-right-radius: 0.8rem;
        }

        &:last-child {
          border-bottom-left-radius: 0.8rem;
          border-bottom-right-radius: 0.8rem;
        }

        &:last-child:hover {
          border-bottom-left-radius: 0.8rem;
          border-bottom-right-radius: 0.8rem;
          background: rgba(255, 46, 62, 0.05);
        }

        &:not(:last-child):hover {
          background: rgba(50, 54, 80, 0.05);
        }

        > a {
          width: auto;
          height: 3.6rem;
          display: flex;
          align-items: center;
          padding: 0 1.55rem;

          > svg {
            margin-right: 1rem;
            visibility: visible;
          }
        }
      }
    }
  }
`;

export const NotificationIconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &.animate {
    animation: bellShake 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform-origin: top center;
  }

  @keyframes bellShake {
    0% {
      transform: rotate(0);
    }
    15% {
      transform: rotate(10deg);
    }
    30% {
      transform: rotate(-10deg);
    }
    45% {
      transform: rotate(6deg);
    }
    60% {
      transform: rotate(-6deg);
    }
    75% {
      transform: rotate(3deg);
    }
    85% {
      transform: rotate(-3deg);
    }
    92% {
      transform: rotate(1deg);
    }
    100% {
      transform: rotate(0);
    }
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #ff3b30;
  color: white;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-sizing: border-box;
  animation: badgePulse 1s infinite;

  @keyframes badgePulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const DropdownPerfilContainer = styled.div`
  cursor: pointer;
  display: flex;
  margin: 0px 0.5em 0px 1.8em;
  position: relative;
  width: auto;

  > button {
    display: flex;
    align-items: center;
  }

  // The 'nav' item corresponds to Dropdown Component
  > nav {
    z-index: 1500;
    background: #ffffff;
    border-radius: 0.8rem;
    position: absolute;
    top: 3rem;
    right: -1rem;
    width: auto;
    min-width: 16rem;
    box-shadow: 0px 10px 30px rgba(85, 85, 85, 0.16);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-20px);
    transition:
      opacity 0.3s ease,
      transform 0.3s ease,
      visibility 0.3s;

    &.visible {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    &.hidden {
      display: none;
    }

    > ul {
      width: auto;
      padding: 0;
      margin: 0;

      > li {
        white-space: nowrap;
        font-size: 1rem;
        transition: background 0.3s;

        &:first-child {
          border-top-left-radius: 0.8rem;
          border-top-right-radius: 0.8rem;
        }

        &:last-child {
          border-bottom-left-radius: 0.8rem;
          border-bottom-right-radius: 0.8rem;
        }

        &:last-child:hover {
          border-bottom-left-radius: 0.8rem;
          border-bottom-right-radius: 0.8rem;
          background: rgba(255, 46, 62, 0.05);
        }

        &:not(:last-child):hover {
          background: rgba(50, 54, 80, 0.05);
        }

        > a {
          width: auto;
          height: 3.6rem;
          display: flex;
          align-items: center;
          padding: 0 1.55rem;

          > svg {
            margin-right: 1rem;
            visibility: visible;
          }
        }

        > button {
          width: auto;
          height: 3.6rem;
          display: flex;
          align-items: center;
          padding: 0 1.55rem;

          > svg {
            margin-right: 1rem;
            visibility: visible;
          }
        }
      }
    }
  }
`;

export const UserAvatar = styled.div<UserAvatarProps>`
  font-size: 1rem;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  background: url(${props => props.$avatarSrc}) no-repeat center;
  background-size: cover;
  margin-right: 0.4rem;
`;
